import * as React from 'react';
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';
import { parseUrl } from 'query-string';
const Search = (prop) => {
    // something like: ?x=123&foo=bar in the URL
    const [searchValue, setSearchValue] = useQueryParam('query', NumberParam);

    var queryFilter=parseUrl(window.location.href);
    var state = {
        searchVal: "",
        typing: false,
        typingTimeout: 0,
        clearSearch:false
    }
    if(typeof queryFilter.query.query!=="undefined"){
            if(queryFilter.query.query.trim().length>0){
                state.searchVal=queryFilter.query.query;
                state.clearSearch=true;

            }
    }

    const clearSearch=()=>{
        state.clearSearch=false;
        if (state.typingTimeout) {
            clearTimeout(state.typingTimeout);
        }
        setSearchValue(undefined);
        state.searchVal="";
        document.getElementsByClassName('filter-search-input')[0].value="";
        prop.searchFilter();
    }
    const searchOnChange=(evt)=>{
        const val = evt.target.value;

        if(val.trim().length>0){
            if (state.typingTimeout) {
                clearTimeout(state.typingTimeout);
            }

            state.clearSearch=true;
            state.searchVal=val;
            state.typing=false;
            state.typingTimeout=setTimeout(function () {
                setSearchValue(state.searchVal);
                prop.searchFilter();

            }, 1000);
        } else{
            state.clearSearch=false;

            if (state.typingTimeout) {
                clearTimeout(state.typingTimeout);
            }
            if(typeof queryFilter.query.query!=="undefined") {
                setSearchValue(undefined);
                if (queryFilter.query.query.trim().length > 0) {
                    prop.searchFilter();
                }
            }


        }
    }
    return (




        <div className="sidebar-filter-search">
                <span className="bx bx-search-alt form-control-feedback"></span>
            <input className="chat_input filter-search-input" type="text"
                   defaultValue={state.searchVal}
                   onChange={evt => searchOnChange(evt)}
                   placeholder="Search in archives"/>
                    {state.clearSearch === true &&
                    <button
                        onClick={clearSearch}
                        className="search-filter-remove-button"
                    >
                        <i className="bx bx-x"></i>
                    </button>
                    }

        </div>
    );
};

export default Search;
